import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterHorizontal,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { CheckBox } from '../General/Checkbox';
import { Select } from '../General/Select';
import { Address } from '../Form/Address';
import { Title } from '../General/Text';
import { FormInput, FormWrapper } from '../Form/FormInput';

interface Props {
  street: string;
  streetNumber: string;
  city: string;
  zip: string;
  country_id: string;
  onChange: any;
  isPreffered: boolean;
  isNew: boolean;
}

function AddressChangeForm({
  street,
  streetNumber,
  city,
  zip,
  country_id,
  isPreffered,
  onChange,
  isNew,
}: Props) {
  return (
    <Wrapper>
      <StyledTitle marginTop={0} marginBottom={32}>
        {isNew ? __('Pridať novú adresu') : __('Upraviť adresu')}
      </StyledTitle>
      <AddressWrapper>
        <AddressFormWrapper marginRigh={32}>
          <FormInput
            name="street"
            type="text"
            label={__('Ulica')}
            value={street}
            maxWidth={100}
            maxWidthPx={224}
            maxWidthMobilePx={224}
            marginRight={16}
            shrink={1}
            onChange={onChange}
            required={true}
          />
          <FormInput
            name="streetNumber"
            type="text"
            label={__('Číslo')}
            value={streetNumber}
            maxWidth={34}
            maxWidthPx={80}
            maxWidthMobilePx={80}
            onChange={onChange}
            required={true}
          />
        </AddressFormWrapper>
        <AddressFormWrapper>
          <FormInput
            name="city"
            type="text"
            label={__('Mesto')}
            value={city}
            maxWidth={100}
            maxWidthPx={224}
            maxWidthMobilePx={224}
            marginRight={16}
            shrink={1}
            onChange={onChange}
            required={true}
          />
          <FormInput
            name="zip"
            type="text"
            label={__('PSČ')}
            value={zip}
            maxWidth={34}
            maxWidthPx={80}
            maxWidthMobilePx={80}
            onChange={onChange}
            required={true}
          />
        </AddressFormWrapper>
      </AddressWrapper>
      <Select
        marginBottom={32}
        name="country_id"
        label={__('Krajina')}
        value={country_id}
        options={[{ value: 'sk', name: 'Slovensko' }]}
        // tslint:disable-next-line:jsx-no-lambda
        onChange={onChange}
        required={true}
        maxWidth={328}
        border={'#EEEEEE'}
      />
      <CheckBox
        rounded={true}
        selected={isPreffered}
        label={__('Predvolená adresa')}
        name="isDefault"
        onClick={onChange}
        border={'#EEEEEE'}
      />
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  margin-bottom: ${rem(32)};

  select {
    border: ${rem(2)} solid #eeeeee;
    width: 100%;
  }

  ${({ theme }) => theme.mediab.m580`
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    align-items: center;
    justify-content: center;
  `}
`;

const StyledTitle = styled(Title)`
  font-size: ${rem(24)};
  line-height: ${rem(31)};
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-bottom: ${rem(32)};
`;

const AddressWrapper = styled(FlexRow)`
  flex-flow: row wrap;
`;

const AddressFormWrapper = styled(FormWrapper)`
  max-width: ${rem(328)};

  ${({ theme }) => theme.mediab.m810`
    flex-flow: row nowrap;
    margin-right: 0;
  `}

  ${({ theme }) => theme.mediab.m580`
    align-items: center;
    justify-content: center;
  `}
`;

export { AddressChangeForm };
